import React, { useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadMedicalServicesByStateAsync, selectMedicalServicesByState } from '../dashboardSlice';
import { ChartCard } from './ChartCard';
import { stateFlagColor } from '../stateColors';

// Fixo (não segue --text-color do tema): esse contorno precisa continuar
// visível tanto contra o fundo claro quanto o escuro do card — um contorno
// que "seguisse" o tema (claro no light, claro no dark) sumiria justamente
// nas barras de bandeira branca (AM/DF/MA/MG/TO) no tema escuro, do mesmo
// jeito que a barra sem contorno nenhum sumia no tema claro.
const BAR_BORDER_COLOR = '#757575';

export const MedicalServicesByStateChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectMedicalServicesByState);

    const chartData = useMemo(() => {
        if (!Array.isArray(data) || !data.length) {
            return {
                labels: [],
                datasets: [{
                    label: 'Serviços por estado',
                    data: [],
                    backgroundColor: [],
                    borderColor: BAR_BORDER_COLOR,
                    borderWidth: 1
                }]
            };
        }

        return {
            labels: data.map(item => item.state),
            datasets: [{
                label: 'Serviços por estado',
                data: data.map(item => item.serviceCount),
                backgroundColor: data.map(item => stateFlagColor(item.state)),
                borderColor: BAR_BORDER_COLOR,
                borderWidth: 1
            }]
        };
    }, [data]);

    return (
        <ChartCard
            title="Serviços médicos por estado"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadMedicalServicesByStateAsync())}
        >
            <Chart type="bar" data={chartData} />
        </ChartCard>
    );
};